module.exports = __webpack_public_path__ + "img/galp.1b9c3af4.jpg";